import { c as _c } from "react/compiler-runtime";
import qrGenerator from 'qrcode-generator';
import type { JSX } from 'react';

/** Vector modules avoid the canvas renderer's overlapping rounded pixel cells. */
export function FundingQr(t0) {
  const $ = _c(20);
  const {
    value
  } = t0;
  let extent;
  let t1;
  if ($[0] !== value) {
    const qr = qrGenerator(0, "H");
    qr.addData(value);
    qr.make();
    const modules = qr.getModuleCount();
    extent = modules + 8;
    t1 = Array.from({
      length: modules
    }, (_, row) => Array.from({
      length: modules
    }, (__0, column) => qr.isDark(row, column) ? `M${column + 4} ${row + 4}h1v1h-1z` : "").join(""));
    $[0] = value;
    $[1] = extent;
    $[2] = t1;
  } else {
    extent = $[1];
    t1 = $[2];
  }
  const path = t1.join("");
  const logoSize = 0.14423076923076922 * extent;
  const logoPadding = 0.028846153846153848 * extent;
  const logoPosition = (extent - logoSize) / 2;
  const t2 = `0 0 ${extent} ${extent}`;
  let t3;
  if ($[3] !== extent) {
    t3 = <rect width={extent} height={extent} fill="white" />;
    $[3] = extent;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== path) {
    t4 = <path d={path} fill="black" />;
    $[5] = path;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = extent / 2;
  const t6 = extent / 2;
  const t7 = logoSize / 2 + logoPadding;
  let t8;
  if ($[7] !== t5 || $[8] !== t6 || $[9] !== t7) {
    t8 = <circle cx={t5} cy={t6} r={t7} fill="white" />;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== logoPosition || $[12] !== logoSize) {
    t9 = <image href="/assets/onramp/morfi-qr-mark.svg" x={logoPosition} y={logoPosition} width={logoSize} height={logoSize} />;
    $[11] = logoPosition;
    $[12] = logoSize;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t8 || $[18] !== t9) {
    t10 = <svg xmlns="http://www.w3.org/2000/svg" width="208" height="208" viewBox={t2} aria-hidden="true">{t3}{t4}{t8}{t9}</svg>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}